import { render, staticRenderFns } from "./CompArticlesThanks.vue?vue&type=template&id=b6182220"
import script from "./CompArticlesThanks.vue?vue&type=script&setup=true&lang=js"
export * from "./CompArticlesThanks.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports